import { BLOCK_REGISTRY } from "../blockRegistry";

const FAQS_DEFAULT_BLOCKS = [
  {
    id: "default-faqs-hero",
    type: "about-hero",
    fields: {
      ...BLOCK_REGISTRY["about-hero"].defaultFields,
      eyebrow: "Support",
      headline: "Frequently Asked Questions",
      subtext: "The essentials on booking, payment, and cancellations.",
    },
  },
  {
    id: "default-faqs-list",
    type: "generic-faq-list",
    fields: {
      eyebrow: "",
      headline: "",
      items: [
        { question: "What can I book with Exqura?", answer: "Exqura lets you discover and book golf courses, ferry travel, ground transportation, and accommodation, primarily for golf travel in Southeast Asia." },
        { question: "When is my booking confirmed?", answer: "Your booking is confirmed once you receive a confirmation email or in-app confirmation from Exqura. Availability isn't guaranteed until then." },
        { question: "How old do I need to be to book?", answer: "You must be at least 18 years old to create an account and make bookings." },
        { question: "Can I cancel my booking?", answer: "You can cancel a confirmed booking from My Bookings up to 24 hours before the booking date. See our Cancellation Policy for details." },
        { question: "How long do refunds take?", answer: "Approved refunds are processed to the original payment method within 7–14 business days, subject to the service provider's policy." },
        { question: "Does Exqura operate the courses, ferries, and hotels?", answer: "No. Exqura acts as an intermediary between you and third-party providers, who may have their own pricing, availability, and terms." },
        { question: "How do I delete my account data?", answer: "Email privacy@exqura.com with the subject line \"Data Deletion Request\". See our Data Deletion page for the full process." },
      ],
    },
  },
];

export default FAQS_DEFAULT_BLOCKS;
